import React from "react";
import PropTypes from "prop-types";

import { Icon, Label } from "semantic-ui-react";

export function StreamsTagsText({ streams, tags }) {
  return (
    <div data-test="streams-tags-text">
      {streams.map((stream) => {
        return (
          <Label
            key={stream.id}
            data-test="condition-streams"
            style={{
              backgroundColor: stream.color,
              color: "#fff",
              padding: "0.3em 0.4em",
              margin: "0 0.5em 0.2em 0",
            }}
          >
            {stream.name}
          </Label>
        );
      })}
      {tags.map((tag) => {
        return (
          <Label
            key={tag.id}
            data-test="condition-tags"
            style={{
              backgroundColor: "grey",
              color: "#fff",
              padding: "0.3em 0.4em",
              margin: "0 0.5em 0.2em 0",
            }}
          >
            <Icon data-test="condition-tags-icon" fitted name="hashtag" />
            &nbsp;
            {tag.name}
          </Label>
        );
      })}
    </div>
  );
}

StreamsTagsText.propTypes = {
  streams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
    })
  ),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

StreamsTagsText.defaultProps = {
  streams: [],
  tags: [],
};

export default StreamsTagsText;
